/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import styles from './index.module.less';
import { milliFormat, phoneNumFormat } from '../../utils/tool';
import webview from '../../utils/webview';
import copy from 'copy-to-clipboard'
import { report, getVoucherGoods, buyVoucher, payVoucherOrder, queryCoin } from '../../services/api';
import { Route, Switch, useLocation, withRouter } from 'react-router-dom';
import TopupRecord from './components/record'

export default class TopupVoucher extends Component {
    state = {
        goodsList: [
            {
                id: 1,
                discount: 1,
                count: 10000
            }
        ],
        vendorList: [
            {
                name: 'VIETTEL',
                cover: require('../../assets/topupvoucher/viettel.png'),
            }, {
                name: 'MOBIFONE',
                cover: require('../../assets/topupvoucher/mobifone.png'),
            }, {
                name: 'VINAPHONE',
                cover: require('../../assets/topupvoucher/vinaphone.png'),
            }
        ],
        userInfo: '',
        selectGood: {
            id: 1,
            discount: 0.1,
            count: 10000
        },
        selectGoodIndex: 0,
        selectVendorIndex: 0,
        tipsInfo: "Chức năng đang được phát triển !",
        showTipsModal: false,
        showDialogModal: false,
        dialogTitle: '',
        dialogContent: '',
        dialogOnCancel: null,
        dialogOnConfirm: null,
        loadingInfo: '',
        showLogModal: false,
        showLoadingModal: false,
        userName: 'Đăng nhập',
        userAvator: require('../../assets/recharge/avatarDefault.png'),
        showSubmitContent: true,
        navTitleWords: 'Nạp tiền điện thoại',
        selectVendor: 'VIETTEL',
        submitOrderInfo: '',
        dialogTopBtnText: '',
        dialogBottomBtnText: '',
        appVersion: '',
        cardQuantity: 1,
        coinDeduct: 0,
        currentCoin: 0,
        overCoinTipsShow: false,
    }

    componentDidMount() {
        this.getPhoneInfo();
        this.getGoodsList();
        this.getUserInfo(true);
        window.addEventListener('popstate', (state) => {
            console.log(state);
            this.setState({
                showSubmitContent: true,
                navTitleWords: 'Nạp tiền điện thoại',
            });
        });
        if (this.props.location.pathname.indexOf("record") > -1) {
            this.setState({
                showSubmitContent: false
            });
        } else if (this.props.location.pathname.indexOf("payresult") > -1) {//支付成功中转页面，判断UA是否是在webview中，选择对应的deeplink
            let urlStr = window.location.href.match(/url=(\S*)/);
            let mch_url = urlStr[1];
            if (mch_url) {
                this.setState({
                    showSubmitContent: false
                });
                if (navigator.userAgent.indexOf('vtopupvoucher') > -1) {
                    mch_url = 'vntopnewslocal://webview?process_type=1&url=' + mch_url;
                } else {
                    mch_url = 'baohay24h://ussdpay?link=vntopnewslocal://webview?process_type=1&url=' + mch_url;
                }
                window.location.href = mch_url;
            }
        }
        this.showLoading();
    }

    componentWillUnmount() {
        window.removeEventListener('popstate');
    }

    sendFail = () => {
        this.setState({ showTipsModal: true, tipsInfo: 'Tạm thời chưa hỗ trợ !' }, () => {
            setTimeout(() => {
                this.setState({ showTipsModal: false, tipsInfo: '' })
            }, 1500)
        })
    }

    // 获取用户设备信息
    getPhoneInfo = () => {
        const { vendorList } = this.state;
        webview.getPhoneInfo().then(res => {
            if (res && res.ret === 0) {
                const { params } = res;
                console.log(params);
                report(res);
                this.setState({
                    appVersion: params.app_ver
                });
            }
        }).catch(e => {
            console.log("获取手机信息失败");
            report({ ...e, msg: 'not in app' });
        })
    }

    //如果是在componentDidMount中调用，获取到用户信息之后判断路由是否需要跳转至record
    getUserInfo = (onMountFlag) => {
        webview.userInfo().then(res => {
            console.log(res);
            if (res && res.ret === 0) {
                const { params } = res;
                if (params.login_token && params.user) {
                    this.setState({
                        userInfo: params
                    }, this.getCoinNum);
                    if (params.user.avatar) {
                        this.setState({
                            userAvator: params.user.avatar
                        });
                    }
                    if (params.user.nickname) {
                        this.setState({
                            userName: params.user.nickname
                        });
                    } else {
                        this.setState({
                            userName: ""
                        });
                    }
                    if (onMountFlag) {
                        if (this.props.location.pathname.indexOf("vtopuprecord") > -1) {//如果是充值成功之后的返回，则直接跳转至record
                            this.setState({
                                navTitleWords: 'Đơn hàng của tôi'
                            });
                            this.props.history.push('/vtopup/record', { userInfo: params });
                        }
                    }
                }
            }
        });
    }

    getCoinNum = () => {
        const { userInfo } = this.state;
        let data = {
            "app_id": 1,
            "user_id": userInfo.uid,
        };
        let hearder = {
            "app-id": 1,
            "user-id": userInfo ? userInfo.uid : '',
            "token": userInfo ? userInfo.login_token : '',
        };
        queryCoin(data, hearder).then(res => {
            if (res && res.code === 0) {
                this.setState({
                    currentCoin: res.coin,
                }, this.calcDefaultCoin)
            }
        });
    }

    calcDefaultCoin = () => {
        const { currentCoin, selectGood, cardQuantity } = this.state;
        var num = 0;
        if (currentCoin >= selectGood.maxCoinDeduct * cardQuantity) {
            num = selectGood.maxCoinDeduct * cardQuantity;
        } else {
            num = Math.floor(currentCoin / 500) * 500;
        }
        this.setState({
            coinDeduct: num
        })
    }

    selectItem = (item, index) => {
        if (item) {
            this.setState({
                selectGood: item,
                selectGoodIndex: index
            }, this.calcDefaultCoin)
        }
    }

    selectVendor = (item, index) => {
        if (item) {
            this.showLoading();
            this.setState({
                selectVendorIndex: index,
                selectVendor: item.name,
                selectGoodIndex: 0
            });
            this.getGoodsList(item.name);
        }
    }

    submitAmount = () => {
        const { selectVendorIndex, selectGood, userInfo, appVersion, vendorList, cardQuantity, coinDeduct } = this.state;
        console.log(selectGood);
        if (this.checkLogin()) {
            if (vendorList.length > 0) {
                this.setState({ showTipsModal: true, tipsInfo: 'Đang gửi đơn hàng' })
                //下单
                let data = {
                    "app_id": 1,
                    "user_id": userInfo.uid,
                    "product_id": selectGood.id,
                    "quantity": cardQuantity,
                    "remark": "",
                    "coin_type": 1,
                    "coin_deduct_amount": coinDeduct / 5
                };
                let hearder = {
                    "app-id": 1,
                    "user-id": userInfo ? userInfo.uid : '',
                    "token": userInfo ? userInfo.login_token : '',
                };
                buyVoucher(data, hearder).then(res => {
                    if (res && res.code === 0) {
                        this.setState({
                            showTipsModal: true,
                            tipsInfo: 'Gửi đơn hàng thành công',
                            submitOrderInfo: res.data
                        }, () => {
                            setTimeout(() => {
                                const { submitOrderInfo } = this.state;
                                this.setState({ showTipsModal: true, tipsInfo: 'MoMo Đang mở MOMO' });
                                payVoucherOrder({ 'order_id': submitOrderInfo.id + '' }, {
                                    "app-id": 1,
                                    "user-id": userInfo ? userInfo.uid : '',
                                    "token": userInfo ? userInfo.login_token : '',
                                }).then(payRes => {
                                    if (payRes && payRes.code === 0) {
                                        if (appVersion > '3.17.32') {//版本兼容，3.17.33之前版本不支持设置UA
                                            webview.getUserAgent().then(getUaRes => {
                                                let cacheAgent = sessionStorage.getItem('user_agent');
                                                if (getUaRes && getUaRes.ret == 0) {
                                                    if (!(cacheAgent && cacheAgent !== 'undefined')) {
                                                        getUaRes.params && sessionStorage.setItem('user_agent', getUaRes.params.user_agent);
                                                    }
                                                }
                                                this.showDialog('', 'PHường thức thanh toán', () => {
                                                    console.log('cacheAgent=' + cacheAgent);
                                                    if (cacheAgent && cacheAgent !== 'undefined') {
                                                        webview.changeUserAgent({
                                                            params: {
                                                                'user_agent': cacheAgent
                                                            }
                                                        }).then(response => {
                                                            window.location.href = payRes.pay_url;
                                                        });
                                                    } else {
                                                        window.location.href = payRes.pay_url;
                                                    }
                                                }, () => {
                                                    webview.changeUserAgent({
                                                        params: {
                                                            'user_agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/92.0.4515.107 Safari/537.36 vtopupvoucher'
                                                        }
                                                    }).then(response => {
                                                        window.location.href = payRes.pay_url;
                                                    });
                                                }, 'App MoMo', 'Hiện thị QR Code của MoMo');
                                            });
                                        } else {
                                            window.location.href = payRes.pay_url;
                                        }
                                    } else {
                                        this.setState({ showTipsModal: true, tipsInfo: 'Lấy trang thanh toán thất bại, xin thử lại' });
                                        setTimeout(() => {
                                            this.setState({ showTipsModal: false, tipsInfo: '' });
                                        }, 2 * 1000);
                                    }
                                });
                            }, 1500);
                        });
                    } else {
                        this.setState({ showTipsModal: true, tipsInfo: 'Đăng đơn hàng thất bại, xin thử lại' });
                        setTimeout(() => {
                            this.setState({ showTipsModal: false, tipsInfo: '' });
                        }, 2 * 1000);
                    }
                    console.log(res);
                });
            } else {
                this.showDialog('', 'Không nhận được Sim');
            }
        }
    }

    getGoodsList = (vendor) => {
        const { selectVendor, userInfo } = this.state;
        const currentVendor = vendor || selectVendor;
        getVoucherGoods({
            "app_id": 1,
            "vendor": currentVendor
        }, {
                "app-id": 1,
                "user-id": userInfo ? userInfo.uid : '',
                "token": userInfo ? userInfo.login_token : '',
            }).then(res => {
                if (res && res.code === 0) {
                    this.hideLoading();
                    if (res.data.length > 0) {
                        let goodsList = res.data.map(item => {
                            return {
                                count: item.topup_amount,
                                discount: (1 - item.price_amount / item.topup_amount).toFixed(2),
                                id: item.id,
                                maxCoinDeduct: item.max_coin_deduct * 5   //返回值是盾，对应金币x5
                            }
                        });
                        this.setState({
                            goodsList: goodsList,
                            selectGood: goodsList[0]
                        }, this.calcDefaultCoin);
                    } else {
                        this.showDialog('', 'Hệ thống lỗi, hãy thử lại sau');
                    }

                } else {
                    this.showDialog('', 'Hệ thống lỗi, hãy thử lại sau');
                }
            });
    }


    checkLogin = () => {
        const { userInfo } = this.state;
        if (!userInfo.uid || !userInfo.login_token) {//uid为空时，拉起登录界面
            this.showDialog('', 'Bạn chưa đăng nhập, xin đăng nhập', () => { }, () => {
                webview.login().then(res => {//登录成功
                    if (res === 1) {
                        this.getUserInfo();
                    }
                });
            });
            return false;
        } else {
            return true;
        }
    }

    onHistoryBtn = () => {
        const { userInfo } = this.state;
        if (this.checkLogin()) {
            this.setState({
                navTitleWords: 'Đơn hàng của tôi',
                showSubmitContent: false
            });
            this.props.history.push('/vtopup/record', { userInfo: userInfo });//需要响应安卓返回按键，使用子路由实现
        }
    }

    showLoading = (info) => {
        this.setState({
            loadingInfo: info,
            showLoadingModal: true
        });
    }

    hideLoading = () => {
        this.setState({
            showLoadingModal: false,
            loadingInfo: ''
        });
    }

    changeBtnColor = (min, max) => {
        const { cardQuantity } = this.state;
        if (cardQuantity === min) {
            this.refs.increase_btn.style.color = '#fc6901';
            this.refs.increase_btn.style.borderColor = '#fc6901';
            this.refs.decrease_btn.style.color = '#b4b4b4';
            this.refs.decrease_btn.style.borderColor = '#b4b4b4';
        } else if (cardQuantity === max) {
            this.refs.decrease_btn.style.color = '#fc6901';
            this.refs.decrease_btn.style.borderColor = '#fc6901';
            this.refs.increase_btn.style.color = '#b4b4b4';
            this.refs.increase_btn.style.borderColor = '#b4b4b4';
        } else {
            this.refs.decrease_btn.style.color = '#fc6901';
            this.refs.decrease_btn.style.borderColor = '#fc6901';
            this.refs.increase_btn.style.color = '#fc6901';
            this.refs.increase_btn.style.borderColor = '#fc6901';
        }
    }

    /* 
    * 显示对话框
    * 当cancelCallback和confirmCallback都为空时，对话框将无法退出
     */
    showDialog = (title, content, cancelCallback, confirmCallback, leftBtnText, rightBtnText) => {
        this.hideLoading();
        const hideDialog = () => {
            this.setState({
                dialogTitle: '',
                dialogContent: '',
                showDialogModal: false,
                dialogOnCancel: null,
                dialogOnConfirm: null
            });
        }
        this.setState({
            dialogTitle: title,
            dialogContent: content,
            showDialogModal: true,
            dialogTopBtnText: leftBtnText ? leftBtnText : '',
            dialogBottomBtnText: rightBtnText ? rightBtnText : '',
        });
        if (Object.prototype.toString.call(cancelCallback) === '[object Function]') {
            this.setState({
                dialogOnCancel: () => {
                    cancelCallback.call(this);
                    hideDialog();
                }
            });
        }

        if (Object.prototype.toString.call(confirmCallback) === '[object Function]') {
            this.setState({
                dialogOnConfirm: () => {
                    confirmCallback.call(this);
                    hideDialog();
                }
            });
        }
    }

    render() {
        const { goodsList, selectGood, vendorList, selectGoodIndex, selectVendorIndex, tipsInfo, showTipsModal, showLogModal,
            userName, userAvator, showDialogModal, dialogTitle, dialogContent, dialogOnCancel, dialogOnConfirm, showSubmitContent,
            navTitleWords, loadingInfo, showLoadingModal, dialogTopBtnText, dialogBottomBtnText, cardQuantity, coinDeduct,
            currentCoin, overCoinTipsShow,
        } = this.state;

        const renderVendorList = () => {
            return vendorList.map((item, index) => {
                if (vendorList.length < 1) {
                    return <></>
                } else {
                    return <div key={index} onClick={this.selectVendor.bind(null, item, index)}>
                        <div className={`${styles.vendorInfoItem} ${selectVendorIndex === index ? styles.vendorSelected : null}`}>
                            <div className={styles.cardCover}>
                                {vendorList && vendorList.length > 0 ? <img src={item.cover} alt={vendorList.name} /> : null}
                            </div>
                        </div>
                    </div>
                }
            });
        }
        const rendergoodsList = () => {
            return goodsList.map((item, index) => {
                return <div className={`${styles.cardItem} ${selectGoodIndex === index ? styles.showSelected : null}`} key={index}
                    onClick={this.selectItem.bind(null, item, index)}>
                    <div className={styles.cardNum}>{milliFormat(item.count)}đ</div>
                    <div className={styles.cardDiscount}>Giảm {item.discount * 100}%</div>
                </div>
            })
        }
        return <div>
            <div className={styles.container}>
                <div className={styles.navWrapper}>
                    <div className={styles.navLogin} onClick={this.checkLogin}>
                        <div>
                            <img src={userAvator} />
                        </div>
                        <span>{userName}</span>
                    </div>
                    {/* <span className={styles.navTitle}>{navTitleWords}</span> */}
                    {showSubmitContent ? <div className={styles.historyBtn} onClick={this.onHistoryBtn}>
                        <span>Thẻ đã mua</span>
                        <img src={require('../../assets/recharge/historyBtn.png')} />
                    </div> : null}
                </div>
                <div className={styles.navHLine}></div>
                {showSubmitContent ? <>
                    <div className={styles.optionWrapper}>
                        <div className={styles.vendorInfo}>
                            {renderVendorList()}
                        </div>
                        <div className={styles.vendorHLine}></div>
                        <div className={styles.cardWrapper}>
                            {rendergoodsList()}
                        </div>
                        <div className={styles.cardQuantityWrapper}>
                            <label>Số lượng:</label>
                            <input ref='increase_btn' className={styles.increaseBtn} type='button' value='+' onClick={() => {
                                if (cardQuantity < 3) {
                                    this.setState({
                                        cardQuantity: cardQuantity + 1
                                    }, () => {
                                        this.changeBtnColor(1, 3);
                                        this.calcDefaultCoin();
                                    });
                                }
                            }}></input>
                            <input disabled className={styles.numContent} value={cardQuantity} type="number" id='cardQuantity' init></input>
                            <input ref='decrease_btn' className={styles.decreaseBtn} type='button' value='-' onClick={() => {
                                if (cardQuantity > 1) {
                                    this.setState({
                                        cardQuantity: cardQuantity - 1
                                    }, () => {
                                        this.changeBtnColor(1, 3);
                                        this.calcDefaultCoin();
                                    });
                                }
                            }}></input>
                        </div>
                        <div className={styles.coinQuantityWrapper}>
                            <label>{`Sử dùng Xu (bạn có ${currentCoin} Xu)`}</label>
                            <input className={styles.increaseBtn} type='button' value='+' onClick={() => {
                                if (coinDeduct + 500 <= Math.min(selectGood.maxCoinDeduct * cardQuantity, currentCoin)) {
                                    this.setState({
                                        coinDeduct: coinDeduct + 500
                                    });
                                } else {
                                    this.setState({
                                        overCoinTipsShow: true
                                    }, () => {
                                        setTimeout(() => {
                                            this.setState({
                                                overCoinTipsShow: false
                                            });
                                        }, 1.5 * 1000);
                                    })
                                }
                            }}></input>
                            <input disabled className={styles.numContent} value={coinDeduct} type="number" id='coinDeduct' init></input>
                            <input className={styles.decreaseBtn} type='button' value='-' onClick={() => {
                                if (coinDeduct >= 500) {
                                    this.setState({
                                        coinDeduct: coinDeduct - 500
                                    });
                                }
                            }}></input>
                            {overCoinTipsShow ? <span className={styles.overCoinTips}>{`Tối đa có thể sử dùng ${Math.min(selectGood.maxCoinDeduct * cardQuantity, Math.floor(currentCoin / 500) * 500)} Xu`}</span> : null}
                        </div>
                        {/* <div className={styles.cardDesc}>Dự kiến chờ 10 phút</div> */}
                    </div>
                    <div className={styles.voucherTips}>
                        <p>
                            1. Dịch vụ cung cấp bởi Bao Hay 24H, hợp tác với các nhà mạng và ví điện tử MoMo. Nếu giao dịch không thành công, sẽ hoàn tiền 100%.<br />
                            2. Sau khi thanh toán thành công, vào "thẻ đã mua" kiểm tra mã thẻ. <br />
                            3. Mọi thắc mắc xin vui lòng kết bạn Zalo: <a style={{ color: 'blue' }} onClick={() => {
                                copy('0795922673');
                                this.setState({ showTipsModal: true, tipsInfo: 'Copy success!' });
                                setTimeout(() => {
                                    this.setState({ showTipsModal: false, tipsInfo: '' });
                                }, 2 * 1000);
                            }}>0795922673</a> (thời gian làm việc 9:00- 17:00, Thứ hai - thứ sáu)
                        </p>
                    </div>
                    <div className={styles.settlementPane}>
                        <div className={styles.countInfo}>
                            <div className={styles.countLine}>
                                <div className={styles.countTitle}>Cần thanh toán :&nbsp;</div>
                                <div className={styles.amount}>{selectGood ? `${milliFormat((selectGood.count - (selectGood.count * selectGood.discount)) * cardQuantity - coinDeduct / 5)}đ` : '0đ'}</div>
                            </div>
                            <div className={styles.discountLine}>
                                <div className={styles.discountTitle}>Số tiền được giảm&nbsp;</div>
                                <div className={styles.disAmount}>{selectGood ? `${milliFormat((selectGood.count * selectGood.discount) * cardQuantity)}đ` : '0đ'}</div>
                            </div>
                            <div className={styles.discountLine}>
                                <div className={styles.discountTitle}>Sử dùng Xu &nbsp;</div>
                                <div className={styles.disCoin}>{coinDeduct ? `${milliFormat(coinDeduct / 5)}đ` : '0đ'}</div>
                            </div>
                        </div>
                        <div className={styles.sendBtn} onClick={this.submitAmount}>Nạp ngay</div>
                    </div>
                </> : null}
                <Switch>
                    <Route path="/vtopup/record" component={TopupRecord}></Route>
                </Switch>
            </div>
            {showTipsModal ? <div className={styles.tipsModal}>
                <div className={styles.tips}>{tipsInfo}</div>
            </div> : null}
            {showDialogModal ? <div className={styles.dialogModal}>
                <div className={styles.dialogWrapper}>
                    <div className={styles.dialogTitle}>{dialogTitle}</div>
                    {dialogContent ? <div className={styles.dialogContent}>{dialogContent}</div> : null}
                    {!dialogTopBtnText ? <div className={styles.dialogButtons}>
                        {dialogOnCancel ? <button className={styles.dialogCancelBtn} onClick={dialogOnCancel}>Hủy</button> : null}
                        {dialogOnConfirm ? <button className={styles.dialogConfirmBtn} onClick={dialogOnConfirm}>Xác nhận</button> : null}
                    </div> :
                        <div className={styles.dialogBigButtons}>
                            {dialogOnCancel ? <button className={styles.bigBtnItem} onClick={dialogOnCancel}>{dialogTopBtnText}</button> : null}
                            {dialogOnConfirm ? <button className={styles.bigBtnItem} onClick={dialogOnConfirm}>{dialogBottomBtnText}</button> : null}
                        </div>}
                </div>
            </div> : null}
            {showLoadingModal ? <div className={styles.loadingModal}>
                <div className={styles.loading}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                {loadingInfo ? <div className={styles.loadingTxt}>{loadingInfo}</div> : null}
            </div> : null}
            <div></div>
        </div >
    }
}